import { FC } from 'react';
import { Helmet } from 'react-helmet';

interface PageTitleProps {
  children: string;
}

export const PageTitle: FC<PageTitleProps> = ({ children }) => {
  return (
    <Helmet>
      <title>DaaS | {children}</title>
    </Helmet>
  );
};
